<script setup>
import MainMenu from '../../components/main/MainMenu.vue'
import MainPage from '../../components/main/MainPage.vue'

import { ref } from 'vue'
import { useQuasar } from 'quasar'
import useAuth from '../../store/auth.store'

const $q = useQuasar()
const auth = useAuth()

const isDrawerOpen = ref(true)

function notifyPasswordReset () {
  if (!auth.user.value.isPasswordReset) {
    $q.notify({
      message: 'Та нууц үгээ солино уу!',
      timeout: 10000,
      color: 'negative',
      actions: [
        { label: 'Хаах', color: 'white' }
      ]
    })
  }
}

// notifyPasswordReset()

</script>

<template lang='pug'>
.main
  q-layout(view='hHh LpR fFf')
    main-menu(:is-drawer-open='isDrawerOpen' @update:is-drawer-open='isDrawerOpen = $event')
    main-page(:is-drawer-open='isDrawerOpen' @update:is-drawer-open='isDrawerOpen = $event')
</template>
